<template>
  <div>
    <div class="form-group row">
      <label :for="this.id" class="col-12 col-lg-4 col-form-label">{{ this.label }}</label>
      <div class="col-12 col-lg-8">
        <i class="fas fa-pound-sign currency-icon" aria-hidden="true" v-show="this.cssStyle !== ''"></i>
        <input
          :type="textType"
          v-bind:class="[this.cssStyle]"
          class="form-control"
          :id="this.id"
          :name="this.id"
          v-model="defaultValue"
          @change="$emit('update', $event.target.id, $event.target.value)"
          v-max-length="this.maxLength"
          v-alpha-numeric-only="this.enableAlphaNumericOnly"
          v-numbers-only="this.enableNumbersOnly"
          v-letters-only="this.enableLettersOnly" />
        <Tooltip v-show="this.showTooltip(this.tooltip, this.helpText)" :helpText="this.helpText" />
        <div class="bg-danger text-white col-12 clear-padding-left text-danger error-message" v-show="this.errors.hasKey(this.id)">
          <span class="" v-text="this.errors.getPropByKey('error', this.id)"></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Tooltip from "@/components/controls/Tooltip.vue";
import htmlControlsMixin from "@/mixins/htmlControls";
import { MaxLength } from "@/directives/MaxLength";
import { AlphaNumericOnly } from "@/directives/AlphaNumericOnly";
import { NumbersOnly } from "@/directives/NumbersOnly";
import { LettersOnly } from "@/directives/LettersOnly";

export default {
  name: "Textbox",
  props: ["helpText", "label", "id", "value", "errors", "tooltip", "css", "inputType", "toUpper", "maxLength", "alphaNumericOnly", "numbersOnly", "lettersOnly"],
  mixins: [htmlControlsMixin],
  components: {
    Tooltip
  },
  directives: {
    MaxLength,
    AlphaNumericOnly,
    NumbersOnly,
    LettersOnly
  },
  data() {
    return {
      key: "value",
      cssStyle: typeof this.css !== "undefined" ? this.css : "",
      toUpperCase: typeof this.toUpper !== "undefined" && this.toUpper === "true",
      textType: typeof this.inputType !== "undefined" ? this.inputType : "text",
      defaultValue: "",
      maxLengthDefault: 30,
      enableAlphaNumericOnly: typeof this.alphaNumericOnly !== "undefined" && this.alphaNumericOnly === true,
      enableNumbersOnly: typeof this.numbersOnly !== "undefined" && this.numbersOnly === true,
      enableLettersOnly: typeof this.lettersOnly !== "undefined" && this.lettersOnly === true
    };
  },
  methods: {},
  mounted() {
    if (this.toUpperCase) {
      var input = document.getElementById(this.id);
      if (input.getAttribute("hasUpper") === null) {
        if (input.type == "text") {
          var vm = this;
          input.addEventListener("input", function (evt) {
            input.value = input.value.toUpperCase();
            vm.$emit("update", this.id, input.value);
          });
        }

        input.setAttribute("hasUpper", "");
      }
    }
  },
  created() {
    this.defaultValue = this.value;
  },
  watch: {
    value(newValue, oldValue) {
      this.defaultValue = newValue;
    }
  }
};
</script>

<style scoped>
</style>